import { Router, Routes } from "@angular/router";
import { LoginComponent } from "./login/login.component";
import { AgendaComponent } from "./agenda/agenda.component";
import { DashboardComponent } from "./dashboard/dashboard.component";
//import { ValidLoginGuard } from "./auth/valid-login.guard";
import { routesDashboard } from "./dashboard/dashboard.routes";
import { catalogosDashboard } from "./catalogos/catalogos.routes";
import { authenticatedGuard } from "./guards/authenticated/authenticated.guard";
import { authGuard } from "./guards/auth/auth.guard";
import { formasEnvio } from "./formas-envio/formas-envio.routes";
import { consulta } from "./search/search.routes";

export const routes: Routes = [
  {
    path: "login",
    component: LoginComponent,
    ///canActivate: [ValidLoginGuard],
  },
  {
    path: "",
    component: DashboardComponent,
    children: [
      ...routesDashboard,
      ...catalogosDashboard,
      ...formasEnvio,
      ...consulta,
    ],
    // canActivate: [authenticatedGuard],
  },
  {
    path: "agenda",
    component: AgendaComponent,
    // canActivate: [authenticatedGuard],
  },
  { path: "", redirectTo: "/login", pathMatch: "full" }, // Ruta por defecto: redirige a /login
  { path: "**", redirectTo: "/login" }, // Manejo de rutas no encontradas, redirige a /login
];
